import { GruppoTerritoriale } from '../gruppo-territoriale';
import { TemplateProfilo } from './template-profilo';


export class TemplatePermessoPerGruppoOrganizzativo {
  idGruppo: string;
  permessi: TemplateProfilo[] = [];
  constructor(gruppoTerritoriale: GruppoTerritoriale) {
    this.idGruppo = gruppoTerritoriale.id;
    this.permessi = [];
  }
}
